var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionEnterprise4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.3675 74.5163C58.0876 83.7965 47.7049 81.013 44.3132 68.3228L41.8024 58.9618C38.3934 46.2889 45.9947 38.6892 58.6807 42.0819L68.0413 44.594C80.7273 47.9838 83.5116 58.3699 74.2144 67.6673L67.3675 74.5163Z",
    fill: "#D7D3F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6209 5.48374C21.898 -3.79643 32.2835 -1.01296 35.6753 11.6773L38.186 21.0383C41.5951 33.7112 33.9938 41.3138 21.3077 37.921L11.9472 35.409C-0.738883 32.0163 -3.52314 21.6302 5.77116 12.3327L12.6209 5.48374Z",
    fill: "#D7D3F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.5048 12.6214C83.7991 21.9189 81.0149 32.2877 68.3288 35.6948L58.9683 38.2069C46.2822 41.5996 38.6809 33.9999 42.0727 21.3097L44.5863 11.9487C47.9781 -0.738658 58.3607 -3.52502 67.655 5.77248L74.5048 12.6214Z",
    fill: "#D7D3F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.48333 67.3785C-3.79657 58.0983 -1.01231 47.7123 11.6767 44.3195L21.0343 41.8075C33.706 38.4003 41.3073 46 37.9155 58.6902L35.4019 68.0513C32.0101 80.7415 21.6274 83.525 12.3331 74.2275L5.48333 67.3785Z",
    fill: "#D7D3F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.6975 39.8556C42.6975 40.1963 42.6313 40.5226 42.5017 40.8373C42.3721 41.1492 42.1878 41.4264 41.9489 41.666C41.707 41.9057 41.4306 42.0905 41.1168 42.2204C40.8029 42.3504 40.4776 42.4168 40.1378 42.4168C39.798 42.4168 39.4727 42.3504 39.1588 42.2204C38.845 42.0905 38.5686 41.9057 38.3267 41.666C38.0878 41.4264 37.9035 41.1492 37.7739 40.8373C37.6415 40.5226 37.5781 40.1963 37.5781 39.8556C37.5781 39.5178 37.6415 39.1915 37.7739 38.8768C37.9035 38.5621 38.0878 38.2849 38.3267 38.0452C38.5686 37.8055 38.845 37.6208 39.1588 37.4908C39.4727 37.3609 39.798 37.2974 40.1378 37.2974C40.4776 37.2974 40.8029 37.3609 41.1168 37.4908C41.4306 37.6208 41.707 37.8055 41.9489 38.0452C42.1878 38.2849 42.3721 38.5621 42.5017 38.8768C42.6313 39.1915 42.6975 39.5178 42.6975 39.8556Z",
    fill: "#D7D3F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionEnterprise4);
export default __webpack_public_path__ + "static/media/icon-section-enterprise-4.66454c05b8c77f2771bbbb4b541138b1b1d0506b78fef560b44daab1ee1ee674.svg";
export { ForwardRef as ReactComponent };